// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eEventDetailsAccessoryText {
  font-size: 12px;
}

.eEventDetailsSummary {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  margin-top: 4px;
}

.eEventDetailsSummary__card {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e3e9f2);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.eEventDetailsSummary__cardHeader {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 54px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border-subtle, #e3e9f2);
}

.eEventDetailsSummary__cardTitle {
  min-width: 0;
  flex: 1 1 auto;
}

.eEventDetailsSummary__cardHeader h3 {
  margin: 0;
  color: var(--text-strong, #162033);
  font-size: 15px;
  font-weight: 750;
  line-height: 1.3;
}

.eEventDetailsSummary__editButton {
  display: inline-flex;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #162033);
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
  cursor: pointer;
}

.eEventDetailsSummary__editButton:hover {
  border-color: var(--border-strong, #aebacd);
  background: var(--surface-hover, #f8fafc);
}

.eEventDetailsSummary__editButton svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.eEventDetailsSummary__list {
  padding: 4px 20px;
}

.eEventDetailsSummary__row {
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr);
  gap: 24px;
  padding: 13px 4px;
  border-top: 1px solid var(--border-subtle, #e3e9f2);
}

.eEventDetailsSummary__row:first-child {
  border-top: 0;
}

.eEventDetailsSummary__label {
  color: var(--text-muted, #68758a);
  font-size: 13px;
  font-weight: 650;
  line-height: 1.55;
}

.eEventDetailsSummary__value {
  min-width: 0;
  color: var(--text-strong, #162033);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.eEventDetailsSummary__value p:last-child {
  margin-bottom: 0;
}

.eEventDetailsSummary__value--empty {
  color: var(--text-subtle, #9aa7b8);
  font-style: italic;
}

.eEventDetailsSummary__staffChips {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px 8px;
}

.eEventDetailsSummaryStaffChip {
  display: inline-flex;
  min-height: 40px;
  max-width: 100%;
  align-items: center;
  gap: 10px;
  padding: 4px 10px 4px 4px;
  border: 1px solid #dce6ee;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);
}

.eEventDetailsSummaryStaffChip__avatar {
  flex: 0 0 auto;
}

.eEventDetailsSummaryStaffChip__avatarImg,
.eEventDetailsSummaryStaffChip__avatarFallback {
  display: block;
  width: 30px;
  height: 30px;
  border: 1px solid #dbe5ed;
  border-radius: 999px;
}

.eEventDetailsSummaryStaffChip__avatarImg {
  object-fit: cover;
  background: #fff;
}

.eEventDetailsSummaryStaffChip__avatarFallback {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #dfeaf3 0%, #cfdce8 100%);
  color: #4a5d6e;
  font-size: 12px;
  font-weight: 700;
}

.eEventDetailsSummaryStaffChip__name {
  min-width: 0;
  overflow: hidden;
  color: #425466;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .eEventDetailsSummary__cardHeader,
  .eEventDetailsSummary__list {
    padding-left: 16px;
    padding-right: 16px;
  }

  .eEventDetailsSummary__cardHeader {
    align-items: flex-start;
    flex-direction: column;
  }

  .eEventDetailsSummary__row {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SchoolEventDetailsSummary/SchoolEventDetailsSummary.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;AACF","sourcesContent":[".eEventDetailsAccessoryText {\n  font-size: 12px;\n}\n\n.eEventDetailsSummary {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 16px;\n  margin-top: 4px;\n}\n\n.eEventDetailsSummary__card {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e3e9f2);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.eEventDetailsSummary__cardHeader {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-height: 54px;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border-subtle, #e3e9f2);\n}\n\n.eEventDetailsSummary__cardTitle {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.eEventDetailsSummary__cardHeader h3 {\n  margin: 0;\n  color: var(--text-strong, #162033);\n  font-size: 15px;\n  font-weight: 750;\n  line-height: 1.3;\n}\n\n.eEventDetailsSummary__editButton {\n  display: inline-flex;\n  height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #162033);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.eEventDetailsSummary__editButton:hover {\n  border-color: var(--border-strong, #aebacd);\n  background: var(--surface-hover, #f8fafc);\n}\n\n.eEventDetailsSummary__editButton svg {\n  width: 15px;\n  height: 15px;\n  flex: 0 0 auto;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.eEventDetailsSummary__list {\n  padding: 4px 20px;\n}\n\n.eEventDetailsSummary__row {\n  display: grid;\n  grid-template-columns: 210px minmax(0, 1fr);\n  gap: 24px;\n  padding: 13px 4px;\n  border-top: 1px solid var(--border-subtle, #e3e9f2);\n}\n\n.eEventDetailsSummary__row:first-child {\n  border-top: 0;\n}\n\n.eEventDetailsSummary__label {\n  color: var(--text-muted, #68758a);\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.55;\n}\n\n.eEventDetailsSummary__value {\n  min-width: 0;\n  color: var(--text-strong, #162033);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.55;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.eEventDetailsSummary__value p:last-child {\n  margin-bottom: 0;\n}\n\n.eEventDetailsSummary__value--empty {\n  color: var(--text-subtle, #9aa7b8);\n  font-style: italic;\n}\n\n.eEventDetailsSummary__staffChips {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  gap: 6px 8px;\n}\n\n.eEventDetailsSummaryStaffChip {\n  display: inline-flex;\n  min-height: 40px;\n  max-width: 100%;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 10px 4px 4px;\n  border: 1px solid #dce6ee;\n  border-radius: 999px;\n  background: #fff;\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);\n}\n\n.eEventDetailsSummaryStaffChip__avatar {\n  flex: 0 0 auto;\n}\n\n.eEventDetailsSummaryStaffChip__avatarImg,\n.eEventDetailsSummaryStaffChip__avatarFallback {\n  display: block;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #dbe5ed;\n  border-radius: 999px;\n}\n\n.eEventDetailsSummaryStaffChip__avatarImg {\n  object-fit: cover;\n  background: #fff;\n}\n\n.eEventDetailsSummaryStaffChip__avatarFallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #dfeaf3 0%, #cfdce8 100%);\n  color: #4a5d6e;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.eEventDetailsSummaryStaffChip__name {\n  min-width: 0;\n  overflow: hidden;\n  color: #425466;\n  font-size: 13px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 767px) {\n  .eEventDetailsSummary__cardHeader,\n  .eEventDetailsSummary__list {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .eEventDetailsSummary__cardHeader {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .eEventDetailsSummary__row {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
